import { useMutation, useQuery } from "@tanstack/react-query";
import { createNewProject, getProjectDetails } from "../api/create-project-service";
export const useCreateProjectMutate = (partyNumber) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (createProjectRequest) => {
            return createNewProject(partyNumber, createProjectRequest);
        },
        retry: false
    });
};
export const useGetProjectDetailsQuery = (projectId, partyNumber) => {
    return useQuery({
        enabled: false,
        gcTime: 0,
        queryFn: async () => {
            return await getProjectDetails(projectId, partyNumber);
        },
        queryKey: [projectId, partyNumber],
        retry: false
    });
};
